import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  AvancementState,
  loadAvancementsAction,
  loadAvancementsErrorAction,
  loadAvancementsSuccessAction,
  selectIsAvancementInitialized,
} from './avancement.store';
import { AvancementService } from '../../_services/http/avancement.service';

@Injectable()
export class AvancementEffect {
  constructor(
    private service: AvancementService,
    private actions$: Actions,
    private store: Store<AvancementState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadAvancementsAction),
      withLatestFrom(this.store.select(selectIsAvancementInitialized)),
      filter(([action, isInitialized]) =>
        action.force === true ? true : !isInitialized
      ),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadAvancementsSuccessAction({ payload })),
          catchError(() => of(loadAvancementsErrorAction()))
        )
      )
    )
  );
}
